import { render, staticRenderFns } from "./LeadFollowUpStrip.vue?vue&type=template&id=a2312536&"
import script from "./LeadFollowUpStrip.vue?vue&type=script&lang=js&"
export * from "./LeadFollowUpStrip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports